export default "__VITE_ASSET__Bly5abv7__"